// Shared chip/tag editor — type + Enter (or comma) to add, × to remove,
// Backspace on an empty draft removes the last chip. Used by the Admin
// Guardrails & Safety floor editor and the per-agent GuardrailFields
// (blocked topics + prohibited phrases). Controlled: value (array) + onChange.

import { useState } from "react";
import { COLORS } from "../theme/colors";

const BORDER = COLORS.border || "#e2e5eb";
const ACCENT = COLORS.accent || "#3b82f6";

export default function ChipInput({ value, onChange, placeholder, disabled, tone = ACCENT }) {
  const [draft, setDraft] = useState("");
  const items = Array.isArray(value) ? value : [];
  const add = (raw) => {
    const parts = String(raw).split(",").map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const next = [...items];
    for (const p of parts) if (!next.includes(p)) next.push(p);
    onChange(next);
    setDraft("");
  };
  const remove = (i) => onChange(items.filter((_, j) => j !== i));
  return (<div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", border: `1px solid ${BORDER}`, borderRadius: 8, padding: "7px 9px", background: disabled ? (COLORS.surfaceHover || "#f1f5f9") : (COLORS.surface || "#fff"), opacity: disabled ? 0.6 : 1 }}>
      {items.map((it, i) => (
        <span key={`${it}-${i}`} style={{ display: "inline-flex", alignItems: "center", gap: 5, background: `${tone}18`, color: tone, border: `1px solid ${tone}55`, borderRadius: 999, padding: "2px 8px", fontSize: 12.5, fontWeight: 600 }}>
          {it}
          {!disabled && (
            <button type="button" aria-label={`Remove ${it}`} onClick={() => remove(i)}
              style={{ background: "none", border: "none", color: tone, cursor: "pointer", fontSize: 14, lineHeight: 1, padding: 0 }}>×</button>
          )}
        </span>
      ))}
      {!disabled && (
        <input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); } else if (e.key === "Backspace" && !draft && items.length) remove(items.length - 1); }} onBlur={() => draft && add(draft)} placeholder={items.length ? "" : (placeholder || "Type and press Enter…")} style={{ flex: 1, minWidth: 120, border: "none", outline: "none", background: "transparent", fontSize: 13, color: COLORS.text }} />
      )}
    </div>
  );
}
